import { actions, ACCOUNT_STORE_NAME, IStore } from './store';
import { frontendActions, LocationType } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi, IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { Dispatch } from '@reduxjs/toolkit';
import { ACCOUNT_API_NAMES } from './apis';

/**
 * Fetchs the minimum data to display an account list, this should be done once per session just after sign in.
 * @returns void
 */ // eslint-disable-next-line unicorn/consistent-function-scoping
export const fetchLeanAccounts = () => async (dispatch: Dispatch<any>) => {
  try {
    const request: CmcWebApi.Account.TradingAccountsRequest2 = {} as any;
    const response = await frontendActions.webTradingApiCall<CmcWebApi.Account.TradingAccountsModel3>(
      ACCOUNT_STORE_NAME,
      ACCOUNT_API_NAMES.TradingAccountsLeanGet1,
      request,
      dispatch
    );
    dispatch(actions.leanAccountsFetched(response.Accounts));
  } catch {}
};

/**
 * Get cash balance for an account
 * @returns void
 */ // eslint-disable-next-line unicorn/consistent-function-scoping
export const fetchCashBalance = (account: string) => async (dispatch: Dispatch<any>) => {
  try {
    const request: CmcWebApi.Account.CashBalanceRefreshRequest1 = {
      SelectedAccount: account
    };
    const response = await frontendActions.webTradingApiCall<CmcWebApi.IntermediaryCompany.CashAccountModel1>(
      ACCOUNT_STORE_NAME,
      ACCOUNT_API_NAMES.CashBalanceRefresh1,
      request,
      dispatch
    );
    dispatch(actions.cashBalanceFetched(response));
  } catch {}
};

export const fetchAccounts =
  // eslint-disable-next-line unicorn/consistent-function-scoping
  (refreshCashBalances?: boolean, refreshMarginLendingData?: boolean) => async (dispatch: Dispatch<any>, getState: () => IStore) => {
    try {
      const hash = getState()[ACCOUNT_STORE_NAME].hash ?? 0;
      const isInitialCall = hash === 0;
      const request: Partial<CmcWebApi.Account.TradingAccountsRequest2> & IWebApiRequestBody = {
        IncludeAccountData: true,
        ExcludeHoldingInAccountData: false,
        IncludeTotals: false,
        IncludeClients: true,
        IncludeSelectedAccount: false,
        IncludeMarginAccountOnly: false,
        IncludeOptionsAccountOnly: false,
        RefreshMarginLendingData: refreshMarginLendingData || isInitialCall,
        RefreshCashBalances: refreshCashBalances || isInitialCall,
        _config: {
          hash
        }
      };
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Account.TradingAccountsModel3>(
        ACCOUNT_STORE_NAME,
        ACCOUNT_API_NAMES.TradingAccountsGet3,
        request,
        dispatch,
        undefined,
        undefined,
        true
      );
      dispatch(actions.accountsFetched({ accounts: response.Accounts, selected: response.SelectedAccountNumber, hash: response._apiInfo?.Hash ?? 0 }));
    } catch {}
  };

// eslint-disable-next-line unicorn/consistent-function-scoping
export const onPollFetchAccounts = () => (dispatch: Dispatch<any>) => {
  dispatch(fetchAccounts());
};

export const subscribeAccounts = (location: LocationType) => async (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.subscribe({
      onPoll: onPollFetchAccounts,
      location,
      apiName: ACCOUNT_API_NAMES.TradingAccountsGet3,
      storeName: ACCOUNT_STORE_NAME,
      pollTimeout: 15_000 // prod default
    })
  );
};

export const unsubscribeAccounts = (location: LocationType) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.unsubscribe({
      location,
      apiName: ACCOUNT_API_NAMES.TradingAccountsGet3,
      storeName: ACCOUNT_STORE_NAME
    })
  );
};

export const selectAccount = (accountNo: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch<any>(actions.accountSelected(accountNo));
    const request: CmcWebApi.Account.AccountSelectionRequest1 = {
      SelectedAccount: accountNo
    };
    await frontendActions.webTradingApiCall(ACCOUNT_STORE_NAME, ACCOUNT_API_NAMES.TradingAccountSavePreferred1, request, dispatch);
  } catch {}
};
